/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 04/06/2023.
 */
import React from 'react'
import { BACKGROUND_FOOTER } from '../constant'
import ArrowIcon from '../assets/next_arrow.svg'

import { Link } from 'gatsby'

const MoreCollections = ({ type = 'SKUFFER' }) => {
  return (
    <div className="container-fluid " style={{ background: BACKGROUND_FOOTER }}>
      <div className="container" style={{}}>
        <div className="row" style={{}}>
          <div className="col-12  col-md-10 mx-auto pt-6 d-flex align-items-center flex-column">
            <div className="text-white">
              <h6 className="text-center " style={{ maxWidth: 500 }}>
                Vi tilbyder mere end bare køkkener
              </h6>
              <h3 className="fw-bold text-center mb-1 mb-md-2">Se andre kollektioner </h3>
            </div>
          </div>
        </div>

        <div className="row" style={{}}>
          <div className="col-12 col-md-10 mx-auto mt-5">
            <div className="row" style={{}}>
              {/*              <div className="col-12 col-md-6">
                <BtnItem to="/bademoebler" title="Se GODMORGON Bademøbler"></BtnItem>
              </div>*/}
              {type === 'SKUFFER' ? (
                <div className="col-12 col-md-6">
                  <BtnItem to="/skuffer" title="Se træskuffer"></BtnItem>
                </div>
              ) : (
                <div className="col-12 col-md-6">
                  <BtnItem to="/koekken" title="Se METOD Køkken"></BtnItem>
                </div>
              )}
              <div className="col-12 col-md-6">
                <BtnItem to="/garderobe" title="Se PAX Garderobe"></BtnItem>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const BtnItem = ({ to = '', title = '--' }) => {
  const size = 50
  return (
    <Link
      to={to}
      className="text-decoration-none pointer d-flex p-4 p-md-5 bg-white my-2 my-md-4 rounded-1 justify-content-between align-items-center"
    >
      <div className="">
        <p className="p-small mb-1">Se flere flotte modeller</p>
        <h6 className="fw-bold text-decoration-underline">{title}</h6>
      </div>
      <ArrowIcon style={{ width: size * 0.4, height: size * 0.5, transform: 'rotate(-90deg)' }}></ArrowIcon>
    </Link>
  )
}

export default MoreCollections
